import { render, staticRenderFns } from "./BirthdayPage.vue?vue&type=template&id=343f0e67&scoped=true"
import script from "./BirthdayPage.vue?vue&type=script&lang=js"
export * from "./BirthdayPage.vue?vue&type=script&lang=js"
import style0 from "./BirthdayPage.vue?vue&type=style&index=0&id=343f0e67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343f0e67",
  null
  
)

export default component.exports